module.exports = __webpack_public_path__ + "static/hero-contact.43896503.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hero-contact.jpeg
// module id = 467
// module chunks = 1354000900563